// Shared colour-name → hex lookup, used by both the design tool (assets/design-tool.js,
// to colour the garment mockup and swatches) and the product page (assets/product.js,
// to colour the Colour dropdown's swatches). One dictionary so both stay in sync —
// edit here, not in either of those files.
window.COLOR_NAME_HEX = {
  white: '#FFFFFF', clear: '#FFFFFF', black: '#323031', navy: '#1E3A8A', blue: '#2563EB',
  red: '#EF041F', maroon: '#7F1D1D', green: '#009169', 'forest green': '#166534',
  yellow: '#F59E0B', gold: '#FBE92E', orange: '#FF7101', purple: '#7C3AED',
  pink: '#FE5784', grey: '#9CA3AF', gray: '#9CA3AF', 'heather grey': '#CBCBCB',
  'heather gray': '#CBCBCB', brown: '#78350F', beige: '#DBBEA4', khaki: '#BFB08A',
  cream: '#F5EFE0', charcoal: '#374151', silver: '#C0C0C0', teal: '#0D9488',

  // B&C Exact 150 (#E150, code BC560301) — sampled directly from the supplier's
  // own product photos (median pixel of a centred fabric crop), so these match
  // the real garment rather than a generic guess. A few (marked below) have no
  // confirmed official name — the PT spec sheet truncates colour names to 12
  // characters — so a descriptive name was used instead; only the *name* is a
  // guess there, not the colour.
  'toasted yellow': '#FFD028', 'peach': '#FEA800', 'dark green': '#295940',
  'pistachio green': '#94B96B', 'orchid green': '#72C12D', 'millennial khaki': '#646760',
  'urban khaki': '#56573B', 'fire red': '#D5002B', 'bordeaux': '#75323F',
  'millennial pink': '#DDB5A7', 'sky blue': '#85BEE7', 'turquoise blue': '#3ACEEB',
  'royal blue': '#004A8F', 'navy blue': '#3D4556', 'azure': '#0081BF',
  'real turquoise': '#009DAF', 'atoll': '#0093C3', 'sailor navy': '#383B4E',
  'diva blue': '#00647A', 'cobalt blue': '#1F4697', 'urban navy': '#383950',
  'electric blue': '#303C6E', 'natural': '#F6E7D6', 'dark heather grey': '#A5A5A5',
  'dark grey': '#47454C',
  // Descriptive names (see comment above) — real sampled colour, not-yet-confirmed official name.
  'used black': '#3F3C3F', 'vintage black': '#3D3A3D', 'deep red': '#524040',
  'tomato red': '#FF3618', 'urban purple': '#604468', 'plum': '#54385C',
  'slate blue': '#3B3B49', 'light navy': '#4E576F',

  // B&C E220 Oversized (code BC560346) — sampled the same way.
  'mastic': '#ACA08F',

  // Names reused across more than one B&C product (e.g. "Navy Blue" exists on
  // the t-shirt, the hoodies, ...) sample very slightly differently per fabric
  // — these two are the average of every product's sample, everything else
  // below is a single product's own sample under its own name.
  'navy blue': '#1E2432', 'royal blue': '#135596',

  // B&C Inspire Hooded (code BC560322, 20-colour hoodie).
  'black pure': '#201D1F', 'yellow fizz': '#F9D967', 'pure orange': '#F76D28',
  'mocha': '#684B41', 'forest green': '#344436', 'sage': '#9BB6A9',
  'apple green': '#40B65C', 'lime': '#D3E37C', 'radiant purple': '#54457C',
  'soft rose': '#EAC4B6', 'magenta pink': '#E92A6E', 'royal': '#153E86',
  'blue fog': '#99AFB9', 'off white': '#E8E0D2', 'asphalt': '#404348',
  'light grey': '#A7A7A8',

  // B&C ID.003 (code BC560007) — the "Basic" hoodie.
  'charcoal grey': '#42484C',

  // B&C Influence Hoodie (code BC560353) — the "Premium" hoodie.
  'amalfi teal': '#3A494E',

  // Popmug two-tone mug (code 370248) — sampled from the coloured interior/
  // handle (the body itself is always plain white ceramic). Reuses the
  // existing "royal blue" from the t-shirts/hoodies above for its own Royal
  // Blue variant rather than overriding it with one shadowed mug photo.
  'yellow': '#DFC676', 'light green': '#A2CC45', 'light pink': '#CBA3B4',

  // B&C #E190 (code BC560303) — the "190" t-shirt, ~40 colours. A handful
  // (marked below) have no confirmed official name for the same reason as
  // the Exact 150's: the PT spec sheet truncates colour names to 12
  // characters — only the *name* is a guess there, not the sampled colour.
  'solar yellow': '#F6E224', 'urban orange': '#FE6B22', 'sunset orange': '#FF3D2F',
  'pixel lime': '#E4E400', 'stone blue': '#4F788A', 'swimming pool': '#00ABC7',
  'millennial lilac': '#8C78A1', 'pacific grey': '#C0C0C0',
  'espresso': '#4D3833', 'chestnut': '#6C4437', 'ice mint': '#AAD8DA',
  'raspberry': '#CD0047', 'blush': '#FED3DA',
  // Code 37, confirmed "Castanho"/Brown by the ID.001 Women polo's own
  // (untruncated) colour table — corrects the "Espresso" guess above, which
  // was made before that confirmation existed.
  'brown': '#403A2E',

  // My Polo 210 (code BC560336) / My Polo 210 LSL (BC560342) / ID.001 Women
  // polo (BC560193) — sampled from their own photos the same way.
  'amalfi yellow': '#F1E198', 'mellow yellow': '#FAD506', 'roasted coffee': '#463633',
  'amalfi coral': '#F0855F', 'tahiti coral': '#F3973C', 'camo green': '#5D5B4E',
  'ivy green': '#16523A', 'amalfi green': '#718E78', 'dark forest': '#2E3836',
  'nude': '#DBA896', 'amalfi grey': '#A19A94', 'heather fog': '#C8C1BA',
  'heather tarmac': '#3D3F42', 'navy pure': '#242835', 'amalfi blue': '#86A4B2',
  'heather blue': '#8C9EBA', 'lake blue': '#3587C8', 'blush pink': '#E3C0BD',
  'heather burgundy': '#462127', 'chili gold': '#DBA234', 'pixel coral': '#E65F54',

  // Caden / Rydell / DIGG-S / Teon caps (codes 380426, 380428, AT610216S,
  // AT610329) — pigment-dyed vintage fabric renders muted/washed even for
  // colours also used elsewhere (e.g. Navy Blue, Bordeaux); those two keep
  // their existing sharper value from the tees/hoodies rather than being
  // dulled down for these caps specifically. "Khaki" is overridden here with
  // a real sample, having previously only had a generic placeholder value.
  'mint green': '#7D9C9A', 'light yellow': '#CBAF70', 'olive green': '#636764',
  'khaki': '#A89F92', 'mustard': '#B79648',
};

window.hexForColorName = function (name) {
  return window.COLOR_NAME_HEX[(name || '').trim().toLowerCase()] || '#9CA3AF';
};
